import { SUBJECT_LIBRARY_TAB_SLUG } from '@yandex-int/k-common';
import { ChevroneKit as Chevrone } from 'education-icons';
import { Button, H1, Link, Text, useIntl, useRouterPath, useSearchParams, useStaticUrls } from 'platform-components';
import { useMemo } from 'react';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { SEARCH_OPEN_MODULE } from 'common.components/constants';
import { getSlugGroupNameWithOrder } from 'utils/get-slug-group-name-with-order';

import './course-container__header.scss';

interface Props {
    title?: string | null;
    moduleOrder?: number;
    isPreview?: boolean;
}

export const LinkBack = ({ isPreview }: { isPreview: boolean | undefined }) => {
    const { labLibraryMain, labClassCoursesPreviewSubjectGrade, labPreviewSubjectGrade, labClassLibrarySubjectTab } =
        useStaticUrls();
    const searchParams = useSearchParams();
    const location = useLocation();
    const params = useParams<Record<string, string>>();
    const pathPartDependentOnTheRole = params.classId // eslint-disable-line no-nested-ternary
        ? isPreview
            ? labClassCoursesPreviewSubjectGrade
            : labClassLibrarySubjectTab
        : isPreview
        ? labPreviewSubjectGrade
        : labLibraryMain;

    const isModulePreview = useMemo(() => searchParams.has(SEARCH_OPEN_MODULE), [searchParams]);

    if (isModulePreview) {
        searchParams.delete(SEARCH_OPEN_MODULE);
    }
    const backToModuleMainPage = `${location.pathname}${
        Array.from(searchParams).length ? `?${searchParams.toString()}` : ''
    }`;

    const linkToMainCourseContainer = useRouterPath(pathPartDependentOnTheRole, {
        tabSlug: SUBJECT_LIBRARY_TAB_SLUG.CONTAINER,
    });

    const currentBackLink = isModulePreview ? backToModuleMainPage : linkToMainCourseContainer;

    return (
        <Link className="course-container__header-return-button" isRouter to={currentBackLink}>
            <Button icon={<Chevrone />} rounded size={Button.SIZE.L} view={Button.VIEW.SECONDARY} />
        </Link>
    );
};

export const CourseContainerHeader = ({ title, moduleOrder, isPreview }: Props) => {
    const intl = useIntl();

    const defaultTitle = title || intl.formatMessage({ id: 'library.collection.header.title' });
    const titleText = moduleOrder ? getSlugGroupNameWithOrder(defaultTitle, moduleOrder) : defaultTitle;

    return (
        <div className="course-container__header">
            <LinkBack isPreview={isPreview} />
            <div className="course-container__header-separator" />
            <H1 type={Text.TYPE.MARKDOWN}>{titleText}</H1>
        </div>
    );
};
